module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#edit",
      toString: function () {
        return this.url;
      }
    }